import { CourseCard } from "src/Views/WisdomAcademy/Components/CourseCard/CourseCard";
import { DesktopCarousel } from "UIPalette/DesktopCarousel/DesktopCarousel";
import { Container } from "shared/UI/LayoutComponents/LayoutComponents";

import { Course } from "shared/request/myHealthyAdvantageApi";

const courseData: Course = {
  id: "7ae6a02c-9ef6-468f-b6ab-23abd55f3d2c",
  status: "NotStarted",
  url: "https://wisdom.healthassured.org/home",
  title: "Test course",
  aboutCourse: "This is used for integration tests",
  timeEstimate: 10,
  description: {
    value: {
      schema: "dast",
      document: {
        type: "root",
        children: [
          {
            type: "heading",
            level: 1,
            children: [
              {
                type: "span",
                value: "Lorem ipsum",
                marks: ["strong"],
              },
              {
                type: "span",
                value: " ",
              },
            ],
          },
          {
            type: "paragraph",
            children: [
              {
                type: "span",
                value:
                  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
              },
            ],
          },
          {
            type: "heading",
            level: 2,
            children: [
              {
                type: "span",
                value: "What you will learn",
              },
            ],
          },
          {
            type: "list",
            style: "bulleted",
            children: [
              {
                type: "listItem",
                children: [
                  {
                    type: "paragraph",
                    children: [
                      {
                        type: "span",
                        value: "Lorem ipsum",
                        marks: ["strong"],
                      },
                    ],
                  },
                ],
              },
              {
                type: "listItem",
                children: [
                  {
                    type: "paragraph",
                    children: [
                      {
                        type: "span",
                        value: "Lorem ipsum",
                        marks: ["emphasis"],
                      },
                    ],
                  },
                ],
              },
              {
                type: "listItem",
                children: [
                  {
                    type: "paragraph",
                    children: [
                      {
                        type: "span",
                        value: "Lorem ipsum",
                        marks: ["underline"],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    },
    blocks: [],
  },
  image: {
    responsiveImage: {
      srcSet:
        "https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.25 580w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.5 1161w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.75 1741w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg 2322w",
      webpSrcSet:
        "https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.25&fm=webp 580w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.5&fm=webp 1161w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg?dpr=0.75&fm=webp 1741w,https://www.datocms-assets.com/93767/1751891435-photo.jpeg?fm=webp 2322w",
      aspectRatio: 1.643312101910828,
      bgColor: "#025bcc",
      width: 2322,
      height: 1413,
      alt: "test",
    },
  },
};

export function ComponentsWisdomAcademy() {
  return (
    <>
      <div className="w-full mx-auto max-w-[400px] space-y-16">
        <CourseCard courseData={courseData} />
        <CourseCard
          courseData={{
            ...courseData,
            status: "Completed",
            aboutCourse: "Learn the great importance of sleep and develop habits that significantly improve sleep quality.",
          }}
        />
      </div>
      <Container>
        <DesktopCarousel>
          <CourseCard courseData={courseData} />
          <CourseCard courseData={courseData} />
          <CourseCard courseData={courseData} />
          <CourseCard courseData={courseData} />
          <CourseCard courseData={courseData} />
          <CourseCard courseData={courseData} />
        </DesktopCarousel>
      </Container>
    </>
  );
}
